import Base from 'app/models/base';

export default Base.extend({});



// WEBPACK FOOTER //
// ./app/models/carrier_type.js